import { getTowlotCatalogRoutine } from 'actions';
import { normalizeTowlotCatalog } from 'helpers/normalizeTowlotCatalog';

export const initialState = {
  loading: false,
  loaded: false,
  error: null,
  data: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case getTowlotCatalogRoutine.REQUEST:
      return { ...state, loading: true, error: null };
    case getTowlotCatalogRoutine.SUCCESS: {
      const raw = action.payload?.data?.towlot_catalog;
      return {
        loading: false,
        loaded: true,
        error: null,
        data: normalizeTowlotCatalog(raw)
      };
    }
    case getTowlotCatalogRoutine.FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default reducer;
